// export type { SearchResult };
export type CommandId = string;
export type CommandHandler = Function;

export type Keybinding = string | string[];
